export default __webpack_public_path__ + "static/media/Visual_joil_23.e1255b43.jpg";